<div class="container">
  <div class="titulos">
    <h1 style="color: #ffffff">¡Hola, {{ user | titlecase }}!</h1>
    <div class="d-flex justify-content-center mt-2">
      <app-hyperlink-icon routerLink="/cambio-contrasena">Cambio de contraseña</app-hyperlink-icon>
    </div>
  </div>

  <div class="circle blue"></div>
  <div class="pt-4">
    <app-tabs [tabs]="myTabs" [defaultTabIndex]="0">

      <!-- Template informacion asesor -->
      <ng-template #infoAsesorTemplate>
        <advisor-information></advisor-information>
      </ng-template>
      <!-- Template informacion asesor -->

      <!-- Template informacion personal -->
      <ng-template #infoPersonalTemplate>
        <personal-information></personal-information>
      </ng-template>

      <ng-template #infoBancariaTemplate>
        <article class="bg-blue-gradient w-100 px-4 py-md-4">
          <h3 class="labelP">Información Bancaria</h3>
          <hr />
          <h5 class="labelS bg-blue-gradient w-100 py-md-2">Datos información bancaria</h5>
          <banking-certification [initialData]="{
              banco: banco,
              tipoCuenta: tipoCuenta,
              numeroCuenta: numeroCuenta
            }" [isUpdate]="isUpdate" (save)="onBankingSave($event)">
          </banking-certification>
        </article>
      </ng-template>
    </app-tabs>
  </div>
</div>